import React from 'react';

export default function BhModal({ open, onClose, title, titleId, children, footer, footerStretch }) {
  if (!open) return null;

  return (
    <div className="bh-modal-root" role="presentation">
      <div className="bh-modal-backdrop" onClick={onClose} aria-hidden="true" />
      <div
        className="bh-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id={titleId} className="bh-modal-title">
          {title}
        </h2>
        <div className="bh-modal-body">{children}</div>
        {footer ? (
          <div className={`bh-modal-footer ${footerStretch ? 'bh-modal-footer--stretch' : ''}`}>{footer}</div>
        ) : null}
      </div>
    </div>
  );
}
